import { render, staticRenderFns } from "./slack_integration.vue?vue&type=template&id=fca9cd20&scoped=true&"
import script from "./slack_integration.vue?vue&type=script&lang=js&"
export * from "./slack_integration.vue?vue&type=script&lang=js&"
import style0 from "./slack_integration.vue?vue&type=style&index=0&id=fca9cd20&scoped=true&lang=css&"
import style1 from "./slack_integration.vue?vue&type=style&index=1&id=fca9cd20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca9cd20",
  null
  
)

export default component.exports